var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExposure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 59"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".exposure_svg__cls-2{fill:#010101}.exposure_svg__cls-5{fill:#e9eaeb}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exposure_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 25,
    r: 25,
    fill: "#f8edda"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38 32h11v26H38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "exposure_svg__cls-2",
    d: "M50 59H37V31h13v28zm-11-2h9V33h-9v24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "exposure_svg__cls-5",
    d: "M8 49h11v9H8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "exposure_svg__cls-2",
    d: "M20 59H7V48h13v11zM9 57h9v-7H9v7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "exposure_svg__cls-5",
    d: "M23 43h11v15H23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "exposure_svg__cls-2",
    d: "M35 59H22V42h13v17zm-11-2h9V44h-9v13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "exposure_svg__cls-2",
    d: "M0 57h62v2H0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c08d42",
    d: "M50 8H38.5l2.9 2.8-14.8 14.8-7.8-7.8L2.6 34.1l5.6 5.7 9.9-10 7.8 7.8L47 16.5l3 2.9V8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "exposure_svg__cls-2",
    d: "M8.2 41.2l-7-7.1 17.7-17.7 7.8 7.8 13.4-13.4L36.3 7h14.9v14.9l-4-4L26.1 39l-7.8-7.8-9.9 9.9zM4 34.1l4.2 4.3 9.9-9.9 7.8 7.8L47 15.2l2 2v-8h-8l1.8 1.8-16.2 16.2-7.8-7.8L3.9 34.3z"
  })))));
}
export default SvgExposure;